(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6644],{

/***/ 3587:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/quality-engineering",
      function () {
        return __webpack_require__(8075);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MethodologyAnchor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


var steps = [
    {
        step: "01",
        title: "Discovery sprint",
        desc: "2 weeks, fixed price. We scope the problem, audit your data, and produce a written roadmap, cost estimate, and risk register. You decide whether to proceed — no commitment beyond the sprint."
    },
    {
        step: "02",
        title: "Build",
        desc: "Fixed-scope first phase or time-and-materials with a cap. Production-grade code, not a prototype. Delivered into your cloud environment with tests, monitoring, and handoff documentation."
    },
    {
        step: "03",
        title: "Operate",
        desc: "4–8 week warranty period post-handoff. Bugs and regressions fixed at zero cost. Ongoing ops available — we don't disappear after delivery."
    }, 
];
function MethodologyAnchor() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "px-8 md:px-[60px] py-14 bg-gray-50 border-t border-gray-100",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-5xl",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-2xl md:text-3xl font-bold text-gray-900 mb-2",
                    children: "How an engagement works"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-gray-500 mb-10 text-base",
                    children: "No open-ended retainers. Every engagement starts with a bounded, fixed-price discovery."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid grid-cols-1 md:grid-cols-3 gap-8",
                    children: steps.map(function(s) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col gap-3",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-3xl font-bold text-[#f1aa4e]",
                                    children: s.step
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "text-lg font-semibold text-gray-900",
                                    children: s.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-gray-600 text-sm leading-relaxed",
                                    children: s.desc
                                })
                            ]
                        }, s.step);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-10",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/itmtb-how-we-work",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "text-blue-600 font-semibold text-sm hover:underline",
                            children: "Full methodology and engagement shapes →"
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 2100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SuccessStoryEmbed; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _blogs_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2684);





var allCaseStudies = _blogs_json__WEBPACK_IMPORTED_MODULE_3__.filter(function(item) {
    var ref;
    return (item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category) === "case-study";
}).map(function(item) {
    return {
        title: item.meta.title || "",
        slug: item.meta.slug || "",
        img: item.meta.img || null,
        industry_descriptor: item.meta.industry_descriptor || null,
        outcome_metric: item.meta.outcome_metric || null,
        refer: Array.isArray(item.meta.refer) ? item.meta.refer : [],
        date: item.meta.date || ""
    };
});
function SuccessStoryEmbed(param) {
    var referTag = param.referTag, _maxItems = param.maxItems, maxItems = _maxItems === void 0 ? 3 : _maxItems, _heading = param.heading, heading = _heading === void 0 ? "Work we've shipped for clients like you" : _heading;
    var stories = referTag ? allCaseStudies.filter(function(s) {
        return s.refer.includes(referTag);
    }) : [];
    if (stories.length === 0) {
        stories = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(allCaseStudies).sort(function(a, b) {
            return b.date > a.date ? 1 : -1;
        });
    }
    var visible = stories.slice(0, maxItems);
    if (!visible.length) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "py-12 px-6 md:px-[60px] bg-gray-50 text-left",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-6xl",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-left",
                    children: heading
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid grid-cols-1 md:grid-cols-3 gap-6 mb-8",
                    children: visible.map(function(story) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/blog/".concat(story.slug),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                className: "group bg-white border border-gray-200 rounded-xl overflow-hidden hover:border-blue-400 hover:shadow-md transition-all flex flex-col",
                                children: [
                                    story.img && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "relative w-full h-44 bg-gray-100",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            src: story.img,
                                            alt: story.title,
                                            fill: true,
                                            className: "object-cover",
                                            sizes: "(max-width: 768px) 100vw, 400px",
                                            placeholder: "blur",
                                            blurDataURL: "/blogImages/hero/placeholder.webp"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "p-5 flex flex-col flex-1",
                                        children: [
                                            story.industry_descriptor && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-blue-500 text-xs uppercase tracking-wide font-medium mb-2",
                                                children: story.industry_descriptor
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: "text-base font-semibold text-gray-900 group-hover:text-blue-600 transition-colors leading-snug mb-3 flex-1",
                                                children: story.title
                                            }),
                                            story.outcome_metric && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-sm text-gray-500 mt-auto pt-3 border-t border-gray-100",
                                                children: story.outcome_metric
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, story.slug);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/success-stories",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "inline-block border border-gray-300 hover:border-blue-500 text-gray-700 hover:text-blue-600 font-semibold px-7 py-3 rounded-lg transition-colors text-sm",
                            children: "See all success stories →"
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 8075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1180);
/* harmony import */ var _blogs_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2684);
/* harmony import */ var _components_services_Service2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3230);
/* harmony import */ var _components_trust_SuccessStoryEmbed__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2100);
/* harmony import */ var _components_services_MethodologyAnchor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(710);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_services_ServiceFAQ__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2616);
/* harmony import */ var _components_services_ServiceEngagementLinks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5733);
/* harmony import */ var _components_ai_agent_demo_CustomerSection__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4837);






var Capabilities2 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5791), __webpack_require__.e(8388), __webpack_require__.e(5290), __webpack_require__.e(7517), __webpack_require__.e(7113)]).then(__webpack_require__.bind(__webpack_require__, 7517));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7517)
            ];
        }
    },
    ssr: false
});







var ContactUsHome = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 6245).then(__webpack_require__.bind(__webpack_require__, 6245));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6245)
            ];
        }
    },
    ssr: false
});
var Footer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 2941).then(__webpack_require__.bind(__webpack_require__, 3193));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3193)
            ];
        }
    },
    ssr: false
});
qualityEng.title = "Quality Engineering & AI Testing Services | ITMTB";
qualityEng.desc = "ITMTB delivers test automation, AI agent testing, and QA management for enterprise software — covering non-deterministic AI systems, CI/CD integration, and production reliability.";
qualityEng.header_img = "https://www.itmtb.com/services/capability/quality.webp";
qualityEng.keywords = "QA consulting India enterprise, test automation India, AI agent testing India, quality engineering services India, testing non-deterministic systems, Playwright Cypress Selenium India, software testing as a service India";
var faqItems = [
    {
        q: "How is testing AI agents different from testing traditional software?",
        a: "Traditional software is deterministic: given the same input, you always get the same output. You can write tests that assert exact outputs and fail reliably when the code is wrong. AI agents are non-deterministic: the same prompt can produce different valid outputs, and the right output changes depending on context, retrieved data, and model version. This means traditional assertion-based testing breaks down. Instead, AI agent testing requires: prompt regression testing — verifying that a given input still produces an output within the acceptable behavioral envelope across model versions; tool-call accuracy testing — checking that agents invoke the right tools with the right parameters for a given scenario; output consistency testing — validating that outputs meet defined structural and semantic constraints rather than matching exactly; and latency and reliability testing — AI systems have higher p99 latency variance than deterministic code, and production SLAs require specific load testing. We've built testing frameworks for production AI agents covering all four areas."
    },
    {
        q: "What testing frameworks do you use and how do you integrate with CI/CD?",
        a: "Framework selection depends on the application stack and what's already in your pipeline. For web application UI testing: Playwright is our default for modern web apps (fast, reliable, good debugging); Cypress for teams that want integrated component testing; Selenium where legacy infrastructure requires it. For API and backend testing: pytest with custom assertion layers for Python services; Jest or Vitest for Node.js APIs; Postman/Newman for contract testing in CI. For performance testing: k6 for developer-friendly load testing in CI pipelines; JMeter for complex enterprise scenarios. For AI agent testing: custom pytest frameworks with LLM evaluation harnesses, prompt regression suites, and behavioral constraint validators. CI/CD integration: we wire test suites into GitHub Actions, GitLab CI, Azure DevOps, or Jenkins depending on your existing setup — with test reporting that gates deployments when critical tests fail."
    },
    {
        q: "What does end-to-end QA management involve and when does it make sense?",
        a: "End-to-end QA management means ITMTB acts as your QA function — owning strategy, test design, execution, and reporting — rather than just providing testing resources. It makes sense when: your internal team is small and QA expertise is expensive to hire full-time; you're scaling a product quickly and need QA capacity that can ramp without long hiring cycles; or QA on your current project is an afterthought and you need a structured reset. What's included: test strategy design (what to test, at what coverage level, with what automation ratio), test framework selection and setup, manual and automated test creation for new features, regression suite maintenance, and defect reporting integrated into your team's workflow. We have managed QA for a Series-A delivery startup whose tech debt was causing production failures, clearing the backlog and establishing a release process that allowed regular shipping without incidents."
    },
    {
        q: "How do you test for performance and reliability in cloud-native applications?",
        a: "Performance testing for cloud-native systems is different from traditional load testing because auto-scaling makes the system behave differently under load than it does at rest. We test at multiple layers: application-level load testing (k6, JMeter) to establish latency profiles at 1\xd7, 5\xd7, and 10\xd7 expected load; database query profiling under concurrent load to identify slow queries that don't appear in unit tests; cold-start behaviour for serverless and containerised components (latency spike on first request after idle); and AI inference endpoint latency under concurrent requests (p50, p90, p99 matter separately for AI workloads). Outputs: a performance baseline report, identified bottlenecks with proposed fixes, and a load test suite you can re-run in CI to catch regressions before they hit production."
    },
    {
        q: "How does ITMTB price an engagement?",
        a: "Pricing follows the engagement model. Discovery sprints are fixed-price for a fixed timebox. Build engagements are scoped after discovery — fixed-scope, time-and-materials, or outcome-linked. Managed services are billed monthly with defined SLAs. Total cost depends on scope, integration complexity, QA depth, and post-launch support — we publish a transparent breakdown for buyers evaluating their options.",
        link: "/blog/custom-software-development-cost-india",
        linkLabel: "Read the cost guide"
    },
    {
        q: "What does an engagement with ITMTB look like?",
        a: "Every engagement starts with a fixed-scope, fixed-price discovery sprint — typically 2 weeks. You leave with a written roadmap, risk register, cost estimate, and timeline before committing to a build. We then offer four engagement models: fixed-scope builds, time-and-materials, outcome-linked retainers, and managed services post-launch. If discovery doesn't justify proceeding, you can stop there — no obligation.",
        link: "/itmtb-how-we-work",
        linkLabel: "See how we work"
    }, 
];
qualityEng.faq = faqItems;
function qualityEng() {
    var insights = _blogs_json__WEBPACK_IMPORTED_MODULE_2__.filter(function(item) {
        var ref;
        return ![
            "case-study",
            "tech"
        ].includes(item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category);
    });
    var caseStudies = _blogs_json__WEBPACK_IMPORTED_MODULE_2__.filter(function(item) {
        var ref;
        return (item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category) === "case-study";
    });
    var filteredInsights = insights.filter(function(item) {
        var ref, ref1;
        return item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : (ref1 = ref.refer) === null || ref1 === void 0 ? void 0 : ref1.includes("Quality Engineering");
    });
    var filteredCaseStudies = caseStudies.filter(function(item) {
        var ref, ref1;
        return item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : (ref1 = ref.refer) === null || ref1 === void 0 ? void 0 : ref1.includes("Quality Engineering");
    });
    if (filteredInsights.length === 1) {
        insights = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(filteredInsights).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__/* .getRandom */ .s)(insights.filter(function(item) {
            return !filteredInsights.includes(item);
        }), 1)));
    } else if (filteredInsights.length >= 2) {
        insights = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__/* .getRandom */ .s)(filteredInsights, 2);
    } else {
        insights = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__/* .getRandom */ .s)(insights, 2);
    }
    if (filteredCaseStudies.length === 1) {
        caseStudies = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(filteredCaseStudies).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__/* .getRandom */ .s)(caseStudies.filter(function(item) {
            return !filteredCaseStudies.includes(item);
        }), 1)));
    } else if (filteredCaseStudies.length >= 2) {
        caseStudies = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__/* .getRandom */ .s)(filteredCaseStudies, 2);
    } else {
        caseStudies = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__/* .getRandom */ .s)(caseStudies, 2);
    }
    var subServices = [
        {
            img: null,
            key: "Testing AI Agents and Non-Deterministic Systems",
            title: "You can't assert exact outputs from an AI agent. You test behavioral envelopes — we've built the frameworks to do it.",
            text: "Testing a production AI system requires different strategies than testing deterministic software. We build testing frameworks covering prompt regression (verifying outputs stay within the acceptable behavioral envelope across model versions), tool-call accuracy (checking agents invoke the right tools with the right parameters), output consistency (structural and semantic constraint validation), and latency bounds under load.\n\nWe've built these frameworks for production AI agents deployed by ITMTB clients. The same infrastructure validates both the model layer and the application logic that wraps it."
        },
        {
            img: null,
            key: "Test Automation Strategy and Infrastructure",
            title: "The right automation strategy: what to automate, at what level, with what framework — and what not to automate.",
            text: "We design automation strategies that match your team's capacity and your product's release cadence. Framework selection based on your stack: Playwright or Cypress for web UIs, pytest for Python services, Jest/Vitest for Node.js, k6 for load testing.\n\nCI/CD integration: test suites wired into GitHub Actions, GitLab CI, Azure DevOps, or Jenkins — with failure gates that block deployments when critical tests fail. We also set test coverage targets that are meaningful rather than arbitrary: coverage of the flows that matter, not 100% line coverage of utility functions."
        },
        {
            img: null,
            key: "QA Management and Execution",
            title: "We act as your QA function — owning strategy, test design, execution, and reporting.",
            text: "For teams where QA is an afterthought or where hiring a full-time QA lead isn't justified, we manage the entire QA function as an extension of your team. This includes: test strategy design, manual and automated test creation for new features, regression suite maintenance, and defect reporting integrated into your team's workflow.\n\nFor a Series-A delivery startup whose tech debt was causing production failures, we cleared the backlog, established a structured release process, and reduced production incidents to near-zero within two months."
        },
        {
            img: null,
            key: "Performance, Load, and API Testing",
            title: "Slow queries that run frequently are expensive. Latency regressions in production AI systems are silent until they're not.",
            text: "We test at multiple layers: application-level load testing (k6, JMeter) at 1\xd7, 5\xd7, and 10\xd7 expected load; database query profiling under concurrent load; cold-start behaviour for serverless and containerised components; and AI inference endpoint latency (p50, p90, p99 profiled separately).\n\nFor API and microservices: contract testing to catch schema drift between services, chaos engineering for failure injection, and integration tests that run against real dependencies rather than mocks."
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_6___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "ProfessionalService",
                            name: "Quality Engineering & AI Testing Services India",
                            url: "https://www.itmtb.com/services/quality-engineering",
                            image: "https://www.itmtb.com/services/capability/quality.webp",
                            description: "ITMTB delivers test automation, AI agent testing, and QA management for enterprise software — covering non-deterministic AI systems, CI/CD integration, and production reliability.",
                            provider: {
                                "@type": "Organization",
                                name: "ITMTB Technologies",
                                url: "https://www.itmtb.com",
                                logo: "https://www.itmtb.com/logo.webp"
                            },
                            areaServed: [
                                {
                                    "@type": "Place",
                                    name: "India"
                                }
                            ],
                            serviceType: [
                                "QA Consulting India",
                                "Test Automation India",
                                "AI Agent Testing",
                                "Quality Engineering Services",
                                "Testing Non-Deterministic AI Systems",
                                "Playwright Cypress Selenium Consulting",
                                "Software Testing as a Service India",
                                "CI/CD Quality Integration", 
                            ],
                            sameAs: [
                                "https://www.linkedin.com/company/itmtb-technologies/",
                                "https://x.com/ITMTBTech",
                                "https://www.instagram.com/itmtbtech/", 
                            ]
                        })
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_Service2__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                heading: "Quality Engineering and AI Testing",
                paragraph: "AI agents that work in demos fail in production for the same reason traditional software does: they weren't tested for the conditions they'd actually face. Non-deterministic AI systems need different testing strategies — and most QA practices weren't designed for them.\n\nWe test AI agents for production: prompt regression, tool-call accuracy, output consistency, and latency bounds under load. For the rest of your software stack, we apply mature automation, performance testing, and QA management that keeps release cycles fast without accumulating the technical debt that causes outages later.\n\nFor a Series-A hyperlocal delivery startup, we cleared a tech debt backlog that was causing production failures and established a release process that allowed regular shipping without incidents.",
                bgPath: "/services/capability/quality.webp",
                primaryCta: {
                    label: "Talk to us →",
                    href: "/contact-us"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_trust_SuccessStoryEmbed__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                referTag: "Quality Engineering",
                maxItems: 3,
                heading: "Selected work in quality engineering"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ai_agent_demo_CustomerSection__WEBPACK_IMPORTED_MODULE_10__/* .CustomerSection */ .a, {
                title: "Trusted by"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_MethodologyAnchor__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Capabilities2, {
                dataList: subServices,
                bg: "bg-[#402A6A]",
                insights: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(caseStudies).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(insights)),
                hideFooter: true,
                hideCardSubtitle: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "px-8 md:px-[60px] py-8 bg-white border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "max-w-4xl text-sm text-gray-500 leading-relaxed",
                    children: [
                        "Quality engineering is one of the specialised practices within our broader",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                            href: "/services/custom-software-development",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "text-indigo-600 font-medium hover:text-indigo-800 transition-colors",
                                children: "custom software development"
                            })
                        }),
                        " ",
                        "capability — the QA and release governance that ships alongside every build."
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_ServiceFAQ__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                items: faqItems
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_ServiceEngagementLinks__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContactUsHome, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Footer, {})
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (qualityEng);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1608,8657,2684,1831,9774,2888,179], function() { return __webpack_exec__(3587); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);